
(function () {
  function setState(wrap) {
    var input = wrap.querySelector('input[type="checkbox"]');
    var btn   = wrap.querySelector('.lb-custom-checkbox');
    if (!input || !btn) return;

    // Drive text via data-attribute on the container (robust)
    btn.setAttribute('data-label', input.checked ? 'Remove' : 'Add');
    btn.classList.toggle('active', input.checked);
  }

  // Delegate clicks from visual button to real input + fire common events
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('card-checkbox .lb-custom-checkbox, .lb-custom-checkbox');
    if (!btn) return;

    var wrap  = btn.closest('.lb-checkbox-cont');
    var input = wrap && wrap.querySelector('input[type="checkbox"]');
    if (!input || input.disabled) return;

    input.checked = !input.checked;
    ['click','input','change'].forEach(function (type) {
      input.dispatchEvent(new Event(type, { bubbles: true }));
    });

    setState(wrap);
  }, { passive: true });

  // Keep visuals in sync if the app toggles it programmatically
  document.addEventListener('change', function (e) {
    if (!(e.target && e.target.matches('.lb-checkbox-cont input[type="checkbox"]'))) return;
    var wrap = e.target.closest('.lb-checkbox-cont');
    if (wrap) setState(wrap);
  });

  // Initial + post-render sync
  function syncAll() {
    document.querySelectorAll('.lb-checkbox-cont').forEach(setState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  // Re-run after app hydrations/renders
  new MutationObserver(function(){ requestAnimationFrame(syncAll); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
